import type { App } from 'vue'
import { createApp } from '@app/adapters/create-app'
import RollForwardOptions from '@app/application/ledger-copier/components/roll-forward-options.vue'

const apps = new WeakMap<Element, App>()

const mountVueApp = (element: Element): void => {
  if (apps.has(element)) {
    return
  }

  const app = createApp(RollForwardOptions)
  app.mount(element)
  apps.set(element, app)
}

const checkAndMountAll = (): void => {
  document
    .querySelectorAll('[data-behaviour~="roll-forward-options"]')
    .forEach((element) => {
      mountVueApp(element)
    })
}

window.onDomLoad(() => {
  checkAndMountAll()

  const observer = new MutationObserver(() => {
    checkAndMountAll()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
})
